import {
  Header,
  Paragraph
} from '@eggplant/pattern-library'

const TestCasesRunTimeInfo = () =>
  <div className='grid gap-3'>
    <Header
      hasNoBottomMargin
      hasNoTopMargin
      rank={5}
    >
      Test cases run time
    </Header>
    <Paragraph>
      This table shows the data of test cases
      runs in the selected monitor configuration.
    </Paragraph>
  </div>

export default TestCasesRunTimeInfo
